import React from 'react';
import { unwrapRTEContent } from '../utils/helpers';
import Image from '../utils/image';

const VariantValueProps = ({ currentVariant }) => {
  if (!currentVariant?.metafields?.valueProps || !currentVariant?.metafields?.valueProps.length) return null;

  const valuePropList = currentVariant?.metafields?.valueProps.map((valueProp, i) => {
    if (i > 2) return null;
    return (
      <div
        className="flex items-center gap-2"
        key={`feature-${i}`}
      >
        <div className="shrink-0 grow-0 basis-5 [&>img]:size-5">
          {valueProp.icon.src ? (
            <Image
              src={valueProp.icon.src}
              height={40}
              width={40}
              alt={valueProp.icon.altText}
            />
          ) : (
            <div className="size-5" />
          )}
        </div>

        <div
          className="body-3 whitespace-nowrap"
          dangerouslySetInnerHTML={{ __html: unwrapRTEContent(valueProp.title) }}
        ></div>
      </div>
    );
  });

  return (
    <div className="grid grid-cols-3 px-0 [&>:nth-child(2)]:justify-self-center [&>:nth-child(3)]:justify-self-end">
      {valuePropList}
    </div>
  );
};

export default VariantValueProps;
